<template>
  <div class="exam_con">
    <h2 class="exam_con_t">成绩查询</h2>
    <div class="exam_bd">
      <ul>
        <li v-for="exam in examList" :key="exam.examResultId">
          <span class="ks_conL">
            <img src="@/assets/images/tb.png" />
          </span>
          <div class="ks_conC">
            <h1 class="cj_tit">{{ exam.examName }}</h1>
            <p class="cj_nr">交卷时间：{{ exam.submitTime }}</p>
            <p>
              <a
                v-if="
                  exam.state > 0 &&
                    exam.visibleAnswerPaper === 2 &&
                    exam.visibleResult === 2
                "
                class="cj_btn"
                href="javascript:void(0);"
                @click="lookTest(exam.examResultId)"
                >查看答卷 >></a
              >
            </p>
          </div>
          <div class="ks_conR">
            <a class="kscj" v-if="exam.state > 0 && exam.visibleResult === 2"
              >{{ exam.finalScore }}分</a
            >
            <a class="kscj" v-if="exam.visibleResult === 1 && exam.state > 0"
              >未公布</a
            >
            <a class="kscj" v-if="exam.state === 0">缺考</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { lookAllScore } from "@/api/login";
export default {
  name: "ScoreQuery",
  data() {
    return {
      tokenBean: {
        token: ""
      },
      examList: [],
      loading: false,
      redirect: undefined
    };
  },
  created() {
    // console.log("token=" + this.token);
    // alert(this.token);
    if (this.token === "") {
      this.$router.push("/login");
    } else {
      this.initData();
    }
  },
  computed: {
    token() {
      return this.getToken();
    }
  },
  methods: {
    initData() {
      this.tokenBean.token = this.token;
      lookAllScore(this.tokenBean).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          this.examList = res.data;
        } else if (res.code === 8003) {
          this.$router.push("/login");
          return;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    lookTest(examResultId) {
      this.$router.push({
        path: "/lookExam",
        query: { examResultId: examResultId }
      });
    },
    notice(str) {
      alert(str);
    },
    joinExam(state, id, allowWeb) {
      if (state === 3) {
        this.$message.error("您已经参加了该试卷的考试。");
        return;
      }
      if (allowWeb === 0) {
        this.$message.error("该试卷不允许在电脑端考试。");
        return;
      }
      this.$router.push({ path: "/Query", query: { examUserId: id } });
    }
  }
};
</script>

<style scoped></style>
